
import Vue from 'vue';
import { Data as HeadlinesData, DataWithHref } from '@root/modules/headlines/types/headlines';
import UniversalHeadlinesService from '@root/modules/headlines/services/UniversalHeadlines.service';
import getHeadlineWithHref from '@root/modules/headlines/utils/getHeadlineWithHref';
import HeadlineBlocks from '@root/common/components/base/headline/HeadlineBlocks.vue';

interface Methods {
  getHeadline: (headline: HeadlinesData) => DataWithHref;
  getTopHeadlines: () => void;
}
interface Computed {
  isSidebarOpen: boolean;
  activeArticleCategoryId: number | undefined;
}

interface Data {
  data: Record<string, any>;
  domain: string;
  headlines: HeadlinesData[];
  limit: number;
  settings: Record<string, any>;
}

export default Vue.extend<Data, Methods, Computed, unknown>({
  components: {
    HeadlineBlocks,
  },
  computed: {
    isSidebarOpen() {
      return this.$store.getters['navigation/getHeaderAction']('sidebar');
    },
    activeArticleCategoryId() {
      return this.$store.getters['article/getActiveArticle']?.primaryCategory.id;
    },
  },
  data() {
    const { domain } = this.$channelConfig('settings');
    return {
      data: {
        items: [],
      },
      domain,
      headlines: [],
      limit: 50,
      settings: {
        channel: false,
        category: false,
        lead: false,
        publishDate: false,
        author: false,
        titleComment: true,
      },
    };
  },
  watch: {
    activeArticleCategoryId(value) {
      if (this.isSidebarOpen) {
        this.$store.commit('navigation/setHeaderAction', { type: 'sidebar', value: false });
      }

      if (value) {
        this.getTopHeadlines();
      }
    },
  },
  mounted() {
    if (process.client) {
      this.$nextTick(() => {
        if (this.activeArticleCategoryId) {
          this.getTopHeadlines();
        }
      });
    }
  },
  methods: {
    getHeadline(headline) {
      const fakeDomainEnabled = this.$config.FAKE_DOMAIN_ENABLED;
      return getHeadlineWithHref({ headline, domain: this.domain, fakeDomainEnabled });
    },
    async getTopHeadlines() {
      const universalHeadlinesService = new UniversalHeadlinesService();
      const headlinesData = await universalHeadlinesService.fetch({ domain: this.domain, categoryId: this.activeArticleCategoryId, limit: this.limit });

      const headlines = headlinesData.items;
      if (headlines.length) {
        this.headlines = headlines.map((headline) => this.getHeadline(headline)) || [];
      }
    },
  },
});
